import { createSelector, createStructuredSelector } from "reselect";
import { initialState, State as ChallengeQuestionState } from "./redux";

/**
 * Direct selector to the challengeQuestion state domain
 */

const selectChallengeQuestionDomain: (any) => ChallengeQuestionState = (
  state
) => state.challengeQuestion || initialState;

/**
 * Custom selectors to the challengeQuestion state
 */
export const selectQuestion = createSelector(
  selectChallengeQuestionDomain,
  (substate) => substate.question
);

export const selectChallengeQuestionError = createSelector(
  selectChallengeQuestionDomain,
  (substate) => substate.showError
);

export const selectChallengeQuestionLoading = createSelector(
  selectChallengeQuestionDomain,
  (substate) => substate.loading
);

export const selectToken = createSelector(
  selectChallengeQuestionDomain,
  (substate) => substate.token
);

export const selectRetries = createSelector(
  selectChallengeQuestionDomain,
  (substate) => substate.noOfRetries
);

export const selectEmailError = createSelector(
  selectChallengeQuestionDomain,
  (substate) => substate.emailError
);

export const selectInvalidCode = createSelector(
  selectChallengeQuestionDomain,
  (substate) => substate.isInvalidCode
);

export const selectEmailExpired = createSelector(
  selectChallengeQuestionDomain,
  (substate) => substate.hasEmailExpired
);

/**
 * Multi instance selectors exporting a factory
 */
export const makeSelectChallengeQuestion = () =>
  createSelector(selectChallengeQuestionDomain, (substate) => substate);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  challengeQuestion: selectQuestion,
  error: selectChallengeQuestionError,
  isLoading: selectChallengeQuestionLoading,
  token: selectToken,
  noOfRetries: selectRetries,
  hasEmailError: selectEmailError,
  isInvalidCode: selectInvalidCode,
  hasEmailExpired: selectEmailExpired,
});
